// React import
import React from 'react';
import {hideNotification, showNotification} from "../../actions";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
// Components import
import ImageWithFallback from "./ImageWithFallback";
// Svg icons import
import { ReactComponent as EthSvg } from '../../svg-icons/coins/eth.svg';
import { ReactComponent as BaseSvg } from '../../svg-icons/coins/base.svg';
import { ReactComponent as BnbSvg } from '../../svg-icons/coins/bnb.svg';
import { ReactComponent as TrendUpSvg } from '../../svg-icons/token-status/trend-up.svg';
import { ReactComponent as TrendDownSvg } from '../../svg-icons/token-status/trend-down.svg';
import { ReactComponent as TrendPumpSvg } from '../../svg-icons/token-status/trend-pump.svg';
import { ReactComponent as TrendDumpSvg } from '../../svg-icons/token-status/trend-dump.svg';
import { ReactComponent as TrendNoSvg } from '../../svg-icons/token-status/trend-no.svg';
import { ReactComponent as CopySvg } from '../../svg-icons/copy.svg';
// Styles imports
import './WalletTokensStatsItem.css';
import '../../util.css'
// Consts imports
import {
    RED,
    ORANGE,
    YELLOW,
    EMERALD,
    GREEN,
    TOKEN_STATS_PNL,
    LEVEL_FEATURES,
    TOKEN_STATS_BUYS,
    TOKEN_STATS_SELLS,
    TOKEN_STATS_FIRST_TX,
    TOKEN_STATS_TRADE_TIME,
    ETH_BLOCKCHAIN,
    ETH,
    BASE,
    BASE_BLOCKCHAIN,
    BSC,
    BSC_BLOCKCHAIN
} from "../../consts/consts";

async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
        return await navigator.clipboard.writeText(text);
    } else {
        return document.execCommand('copy', true, text);
    }
}

class Title extends React.Component {

    constructor(props) {
        super(props);
    }

    setNotification = () => {
        const { showNotification, hideNotification } = this.props;
        const duration = 750;

        showNotification({message: "Token address copied", duration: duration});
        setTimeout(() => {
            hideNotification();
        }, duration);
    }

    handleClick = async () => {
        const { address } = this.props;
        await copyTextToClipboard(address);
        this.setNotification();
    };

    generateRandomKey = () => {
        const characters = '0123456789abcdef';
        let result = '';

        for (let i = 0; i < 6; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }

        return result;
    }

    render() {

        const {symbol, name, index, address, blockchain} = this.props;

        let tokenSymbol = symbol;
        let tokenName = name;

        if (tokenName.length > 12) {
            tokenName = tokenName.slice(0, 12) + '...';
        }

        if (tokenSymbol.length > 8) {
            tokenSymbol = tokenSymbol.slice(0, 8) + '...';
        }

        let blockchainName = ETH_BLOCKCHAIN;
        let fallbackComponent=(<EthSvg className={"check-wallet__token-stats-item__token-icon"}/>);
        if (blockchain === ETH) {
            blockchainName = ETH_BLOCKCHAIN;
            fallbackComponent=(<EthSvg className={"check-wallet__token-stats-item__token-icon"}/>);
        } else if (blockchain === BASE) {
            blockchainName = BASE_BLOCKCHAIN;
            fallbackComponent=(<BaseSvg className={"check-wallet__token-stats-item__token-icon"}/>);
        } else if (blockchain === BSC) {
            blockchainName = BSC_BLOCKCHAIN;
            fallbackComponent=(<BnbSvg className={"check-wallet__token-stats-item__token-icon"}/>);
        }
        blockchainName = blockchainName.toLowerCase();

        return (
            <div className={"check-wallet__token-stats-item__token_title"}>
                <ImageWithFallback
                    src={"https://dd.dexscreener.com/ds-data/tokens/"+blockchainName+"/"+address+".png?size=md&key="+this.generateRandomKey()}
                    fallbackSrc={"https://www.dextools.io/resources/tokens/logos/"+blockchainName+"/"+address+".jpg?"+Date.now()}
                    tertiarySrc={"https://cdn.zerion.io/"+address+".png"}
                    fallbackComponent={fallbackComponent}
                    alt="Example Image"
                    className="check-wallet__token-stats-item__token-icon-png"
                />
                <div className={"check-wallet__token_stats__token-title-description"}>
                    <span className={"check-wallet__token-stats-item__token-index"}>
                        {index + 1}{"."}
                    </span>
                        <span className={"check-wallet__token-stats-item__token-symbol"}>
                        {tokenSymbol}
                    </span>
                        <span className={"check-wallet__token-stats-item__token-name"}>
                        {tokenName}
                    </span>
                    <div className={"check-wallet__token_stats-item__copy-icon-block" } onClick={this.handleClick}>
                        <CopySvg className={"check-wallet__token_stats-item__copy-icon"}/>
                    </div>
                </div>
            </div>
        );
    }
}

function Indicator(props) {

    const {indicator} = props;

    let indicatorStyle = ""

    if (indicator === RED) {
        indicatorStyle = "check-wallet__token-stats-item__item-indicator_red"
    } else if (indicator === ORANGE) {
        indicatorStyle = "check-wallet__token-stats-item__item-indicator_orange"
    } else if (indicator === YELLOW) {
        indicatorStyle = "check-wallet__token-stats-item__item-indicator_yellow"
    } else if (indicator === EMERALD) {
        indicatorStyle = "check-wallet__token-stats-item__item-indicator_emerald"
    } else if (indicator === GREEN) {
        indicatorStyle = "check-wallet__token-stats-item__item-indicator_green"
    } else {
        return null
    }

    return (
        <div className={"check-wallet__token-stats-item__item-indicator " + indicatorStyle}></div>
    );

}

function Icon(props) {

    const { indicator } = props;

    let icon;

    if (indicator === GREEN) {
        icon = (<TrendPumpSvg className={"check-wallet__token-stats-item__status-icon check-wallet__token_stats-item__status-icon_green"}/>);
    } else if (indicator === EMERALD) {
        icon = (<TrendUpSvg className={"check-wallet__token-stats-item__status-icon check-wallet__token_stats-item__status-icon_emerald"}/>);
    } else if (indicator === YELLOW) {
        icon = (<TrendNoSvg className={"check-wallet__token-stats-item__status-icon check-wallet__token_stats-item__status-icon_yellow"}/>);
    } else if (indicator === ORANGE) {
        icon = (<TrendDownSvg className={"check-wallet__token-stats-item__status-icon check-wallet__token_stats-item__status-icon_orange"}/>);
    } else if (indicator === RED) {
        icon = (<TrendDumpSvg className={"check-wallet__token-stats-item__status-icon check-wallet__token_stats-item__status-icon_red"}/>);
    } else {
        return null
    }

    return (
        <div className={"check-wallet__token-stats-item__status-icon-block"}>
            {icon}
        </div>
    )

}

function Stats(props) {
    const { bought, sold, profit, pnl, firstTx, tradeTime, buys, sells, aiLevel} = props;

    let pnlAndProfit = null;
    if (aiLevel < LEVEL_FEATURES[TOKEN_STATS_PNL]) {
        pnlAndProfit = (
            <span className={"check-wallet__token-stats-item__token-stats-text-semibold"}>Profit: {profit}$<br/>PnL: AI level 1</span>
        )
    } else {
        pnlAndProfit = (
            <span className={"check-wallet__token-stats-item__token-stats-text-semibold"}>Profit: {profit}$<br/>PnL: {pnl}%</span>
        )
    }
    let buysAndSellStat = null;
    if (aiLevel < LEVEL_FEATURES[TOKEN_STATS_BUYS] || aiLevel < LEVEL_FEATURES[TOKEN_STATS_SELLS]) {
        buysAndSellStat = (
            <span><br/><br/>Buys: AI level 2<br/>Sells: AI level 2</span>
    )
    } else {
        buysAndSellStat = (
            <span><br/><br/>Buys: {buys}<br/>Sells: {sells}</span>
        )
    }
    let firstTxAndTradeTime = null;
    if (aiLevel < LEVEL_FEATURES[TOKEN_STATS_FIRST_TX] || aiLevel < LEVEL_FEATURES[TOKEN_STATS_TRADE_TIME]) {
        firstTxAndTradeTime = (
            <span><br/>First TX: AI level 3<br/>Trade time: AI level 3</span>
    )
    } else {
        firstTxAndTradeTime = (
            <span><br/>First TX: {firstTx}<br/>Trade time: {tradeTime}</span>
        )
    }

    return (
        <div className={"check-wallet__token-stats-item__token-stats"}>
            <span className={"check-wallet__token-stats-item__token-stats-text"}>
                <span>Bought: {bought}$<br/>Sold: {sold}$<br/></span>
                {firstTxAndTradeTime}
            </span>
            <span className={"check-wallet__token-stats-item__token-stats-text"}>
                {pnlAndProfit}
                {buysAndSellStat}
            </span>
        </div>
);

}

class WalletTokensStatsItem extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        const {
            symbol, name, indicator, bought, sold, profit, pnl,
                firstTx, tradeTime, buys, sells, index, address, aiLevel } = this.props;
        const { showNotification, hideNotification } = this.props;
        const { blockchain } = this.props.blockchain;


        let aiLevelInt = parseInt(aiLevel);

        return (
            <div className={"check-wallet__token-stats-item"}>
                <Indicator indicator={indicator}/>
                <Title symbol={symbol} name={name} index={index} address={address}
                       showNotification={showNotification} hideNotification={hideNotification}
                       blockchain={blockchain}/>
                <Stats bought={bought} sold={sold}
                       profit={profit} pnl={pnl}
                       firstTx={firstTx} tradeTime={tradeTime}
                       buys={buys} sells={sells}
                       aiLevel={aiLevelInt}/>
                <Icon indicator={indicator}/>
            </div>
        );
    }

}

const mapStateToProps = ({checkWallet, notification, blockchain}) => {
    return {checkWallet, notification, blockchain};
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        showNotification: showNotification,
        hideNotification: hideNotification
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(WalletTokensStatsItem);
